import withSuspense from "../../../../hocs/withSuspense";
import { ContactInfoSkeleton, SettingsError } from "../../components";
import DocumentDeliveryPage from "./DocumentDeliveryPage";

export const DocumentDeliveryPageWithSuspense = withSuspense(
  DocumentDeliveryPage,
  {
    FallbackComponent: SettingsError,
    loading: (
      <ContactInfoSkeleton rows={2} testId="document-delivery-skeleton" />
    ),
  }
);
